/* __next_internal_client_entry_do_not_use__ Default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import RelatedArticlesWidget from 'widgets/RelatedArticles';
import PlainTextWrapper from 'helpers/SitecoreWrappers/PlainTextWrapper/PlainTextWrapper';
import useIsEditing from 'lib/hooks/useIsEditing';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import RichTextWrapper from 'helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import useDictionary from 'lib/hooks/useDictionary';
import { getTestProps } from 'lib/testing/utils';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const RelatedArticles = (props)=>{
    const id = props?.params?.RenderingIdentifier;
    const context = useSitecoreContext();
    const page = context?.sitecoreContext?.route;
    const articleTags = page?.fields?.SxaTags || [];
    const isEditing = useIsEditing();
    const { getDictionaryValue } = useDictionary();
    // Get search sources from site settings
    const searchSources = context?.sitecoreContext?.siteSettings?.globalSearchSourceId?.value;
    const noOfRelatedArticleCount = context?.sitecoreContext?.siteSettings?.noOfRelatedArticlesCount?.value;
    // Parse pipe-separated sources into array
    const sources = searchSources ? searchSources.split('|').map((s)=>s.trim()).filter((s)=>s) : [];
    const rfkid = context?.sitecoreContext?.siteSettings?.globalSearchWidgetId?.value;
    if (articleTags.length === 0) {
        if (isEditing) {
            return /*#__PURE__*/ _jsx("div", {
                "data-component": "authorable/shared/page-specific/relatedarticles",
                ...editingHydrationProps(isEditing),
                children: /*#__PURE__*/ _jsx(EditingHelpText, {
                    priority: "warning",
                    children: /*#__PURE__*/ _jsx(RichTextWrapper, {
                        field: {
                            value: getDictionaryValue('NoArticles')
                        },
                        tag: "p"
                    })
                })
            });
        }
        return /*#__PURE__*/ _jsx(_Fragment, {});
    }
    // Get current article tags from the page field data
    const currentArticleTags = Array.isArray(articleTags) ? articleTags.reduce((acc, tag)=>{
        const tagvalue = tag.fields?.Title?.value;
        if (tagvalue) {
            acc.push(tagvalue);
        }
        return acc;
    }, []) : [];
    //Formatted article id for the sitecore search
    const articleIdForSitecoreSearch = context?.sitecoreContext?.route?.itemId ? context.sitecoreContext.route.itemId.replace(/-/g, '').toUpperCase() : '';
    const { base, titleStyle } = TAILWIND_VARIANTS();
    return /*#__PURE__*/ _jsxs("section", {
        className: base(),
        id: id ? id : undefined,
        "data-component": "authorable/shared/page-specific/relatedarticles",
        ...editingHydrationProps(isEditing),
        ...getTestProps(`component-related-articles-${props?.rendering?.uid}`),
        children: [
            /*#__PURE__*/ _jsx(PlainTextWrapper, {
                className: titleStyle(),
                field: props?.fields?.title,
                tag: "h2",
                ...getTestProps(`title`)
            }),
            /*#__PURE__*/ _jsx(RelatedArticlesWidget, {
                rfkId: rfkid || '',
                currentArticleTags: currentArticleTags,
                currentArticleId: articleIdForSitecoreSearch,
                articleLimit: noOfRelatedArticleCount ?? 3,
                searchSources: sources,
                ...getTestProps(`related-articles-widget`)
            })
        ]
    });
};
export const Default = withStandardComponentWrapper(RelatedArticles);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24',
            'text-component-feature-title'
        ],
        titleStyle: [
            'text-component-feature-title',
            'font-typography-font-family-header',
            'text-typography-font-size-medium',
            'leading-typography-line-height-medium',
            'font-bold'
        ]
    }
});
